define('app/views/pagination__view',['app/setup'], function (takhfifan) {

  takhfifan.Pagination = Backbone.View.extend({

    events: {
      'click .tkh-pagination__page': "showPage",
      'click .tkh-pagination__next': "showNextPage",
      'click .tkh-pagination__pre': "showPrePage"
    },

    initialize: function (options) {
      this.count = options.count;
      this.currentPage = options.currentPage;
      this.clickEvent = options.clickEvent;
      this.hideAtStart = options.hideAtStart ? options.hideAtStart : false;

      this.pageAtTime = 3;
      this.pageTempalte = _.template('<li><a href="javascript:void(0)" class="tkh-pagination__page"><%= number %></a></li>');
      this.$nextButton = this.$el.find('.tkh-pagination__next');

      this.on('pagination:pageChanged', function () {
        takhfifan.eventHub.trigger(this.clickEvent, {page: this.currentPage});
        this.render();
      });

      this.render();
    },

    render: function () {
      if (this.count > 0) {

        var pagedDomain = this.calculateStartAndEnd();
        this.clearAllPages();
        this.addPages(pagedDomain.start, pagedDomain.end);
        this.setButtonVisibility();

        if (this.$el.is(":hidden") && !this.hideAtStart) {
          this.$el.show();
        }
      } else {
        this.$el.hide();
      }
    },

    setButtonVisibility: function () {
      if (this.currentPage === 0) {
        this.$el.find('.tkh-pagination__pre').hide();
      } else {
        this.$el.find('.tkh-pagination__pre').show();
      }
      if (this.currentPage === this.count - 1) {
        this.$el.find('.tkh-pagination__next').hide();
      } else {
        this.$el.find('.tkh-pagination__next').show();
      }
    },

    calculateStartAndEnd: function () {
      var itemPerSide = this.pageAtTime % 2;
      var isFirstPage = this.currentPage === 0;

      var start = 0;
      var startReserved = 0;
      if (this.currentPage - itemPerSide >= 0) {
        start = this.currentPage - itemPerSide;
      } else {
        startReserved = (this.currentPage - itemPerSide) * -1;
      }

      var end = this.count - 1;
      var endReserverd = 0;
      if (this.currentPage - itemPerSide <= end) {
        end = this.currentPage + itemPerSide;
        end = end + startReserved <= this.count - 1 ? end + startReserved : this.count - 1;
      } else {
        endReserverd = itemPerSide - ((this.count - 1) - this.currentPage);
      }

      if (endReserverd > 0 && !isFirstPage) {
        start = start - endReserverd >= 0 ? start - endReserverd : 0;
      }

      return {
        start: start,
        end: end
      };
    },

    clearAllPages: function () {
      this.$el.find('.tkh-pagination__page').each(function () {
        $(this).parent().remove();
      });
      this.$el.find('.tkh-pagination__dots-pre').remove();
      this.$el.find('.tkh-pagination__dots-next').remove();
    },

    addPages: function (start, end) {
      var preDot = '<li class="pagination__dots pagination__dots-pre tkh-pagination__dots-pre">...</li>';
      var nextDot = '<li class="pagination__dots pagination__dots-next tkh-pagination__dots-next">...</li>';

      var active = $(this.pageTempalte({number: this.currentPage + 1}));
      active.find('a').addClass('pagination__active');
      var items = [active];
      for (var i = start; i < this.currentPage; ++i) {
        items.unshift($(this.pageTempalte({number: i + 1})));
      }
      if (start > 0) {
        if (start > 1) {
          items.unshift($(preDot));
        }
        items.unshift($(this.pageTempalte({number: 1})));

      }
      for (var i = this.currentPage + 1; i <= end; ++i) {
        items.push($(this.pageTempalte({number: i + 1})));
      }
      if (end < this.count - 1) {
        if (start < this.count - 2) {
          items.push($(nextDot));
        }
        items.push($(this.pageTempalte({number: this.count})));
      }
      var self = this;
      items.forEach(function (item) {
        self.$nextButton.parent().before(item);
      });
    },

    showPage: function (e) {
      this.currentPage = parseInt($(e.currentTarget).text()) - 1;
      this.trigger('pagination:pageChanged');
    },
    showNextPage: function() {
      this.currentPage += 1;
      this.trigger('pagination:pageChanged');
    },
    showPrePage: function() {
      this.currentPage -= 1;
      this.trigger('pagination:pageChanged');
    }

  });
});

